/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Detect_Illegal_Characters_608Inputs */

const en_detect_illegal_characters_608 = /** @type {(inputs: Detect_Illegal_Characters_608Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detect Illegal Chararacters (608)`)
};

const fr_detect_illegal_characters_608 = /** @type {(inputs: Detect_Illegal_Characters_608Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détecter les caractères illégaux (608)`)
};

const de_detect_illegal_characters_608 = /** @type {(inputs: Detect_Illegal_Characters_608Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illegale Zeichen erkennen (608)`)
};

const it_detect_illegal_characters_608 = /** @type {(inputs: Detect_Illegal_Characters_608Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rileva caratteri illegali (608)`)
};

const ru_detect_illegal_characters_608 = /** @type {(inputs: Detect_Illegal_Characters_608Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выявление недопустимых символов (608)`)
};

const es_detect_illegal_characters_608 = /** @type {(inputs: Detect_Illegal_Characters_608Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar personajes ilegales (608)`)
};

const zh_cn2_detect_illegal_characters_608 = /** @type {(inputs: Detect_Illegal_Characters_608Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测非法字符 (608)`)
};

const ja_detect_illegal_characters_608 = /** @type {(inputs: Detect_Illegal_Characters_608Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不正な文字を検出する (608)`)
};

const hi_detect_illegal_characters_608 = /** @type {(inputs: Detect_Illegal_Characters_608Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवैध वर्णों का पता लगाना (608)`)
};

const pt_pt2_detect_illegal_characters_608 = /** @type {(inputs: Detect_Illegal_Characters_608Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar caracteres ilegais (608)`)
};

/**
* | output |
* | --- |
* | "Detect Illegal Chararacters (608)" |
*
* @param {Detect_Illegal_Characters_608Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const detect_illegal_characters_608 = /** @type {((inputs?: Detect_Illegal_Characters_608Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Detect_Illegal_Characters_608Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_detect_illegal_characters_608(inputs)
	if (locale === "de") return de_detect_illegal_characters_608(inputs)
	if (locale === "it") return it_detect_illegal_characters_608(inputs)
	if (locale === "ru") return ru_detect_illegal_characters_608(inputs)
	if (locale === "es") return es_detect_illegal_characters_608(inputs)
	if (locale === "zh-CN") return zh_cn2_detect_illegal_characters_608(inputs)
	if (locale === "ja") return ja_detect_illegal_characters_608(inputs)
	if (locale === "hi") return hi_detect_illegal_characters_608(inputs)
	if (locale === "pt-PT") return pt_pt2_detect_illegal_characters_608(inputs)
	return en_detect_illegal_characters_608(inputs)
});